import { render, staticRenderFns } from "./wisdom_project.vue?vue&type=template&id=7699c2c0&scoped=true&"
import script from "./wisdom_project.vue?vue&type=script&lang=js&"
export * from "./wisdom_project.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_project.vue?vue&type=style&index=0&id=7699c2c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7699c2c0",
  null
  
)

export default component.exports